import { FormTab, AutocompleteInput, TextInput, DateInput, BooleanInput, ArrayInput, SimpleFormIterator } from "ra-ui-materialui";
import { useState, useEffect, useRef } from "react";
import {
    TabbedForm
} from "react-admin";
import { Typography, Paper, Card, Button, CircularProgress, LinearProgress } from '@material-ui/core';
import { useFormState } from "react-final-form";
import { required, FormDataConsumer } from "ra-core";
import { useNotify } from 'react-admin';
import servicePackagesProvider from '../provider/servicePackages.provider';
import plannedActivitiesProvider from '../provider/plannedActivities.provider';
import AutoCompleteCustom from "../components/AutoCompleteCustom"
import ActivitiesTable from "../components/Planned/ActivitiesTable"
import Spinner from '../components/Spinner';
import ConfirmActionDialog from '../components/ConfirmActionDialog';
import { getBusinessErrorMessage } from '../common/apiErrors';
import './plannedActivities.css';


const diasSemana = [
    { id: 1, name: 'Lunes', isCheck: true },
    { id: 2, name: 'Martes', isCheck: true },
    { id: 3, name: 'Miércoles', isCheck: true },
    { id: 4, name: 'Jueves', isCheck: true },
    { id: 5, name: 'Viernes', isCheck: true },
    { id: 6, name: 'Sabado', isCheck: false },
    { id: 0, name: 'Domingo', isCheck: false }
];

const openDatePicker = event => {
    const input = event?.target?.matches?.('input')
        ? event.target
        : event?.currentTarget?.querySelector?.('input[type="date"]');

    if (typeof input?.showPicker === 'function') {
        try {
            input.showPicker();
        } catch (error) {
            input.focus();
        }
    } else {
        input?.focus();
    }
};

/* 
const validatePlannedActivity = (values) => {
    const errors = {};
    if (!values.serviceTypeId) {
        errors.serviceTypeId = 'Requerido';
    }
    if (!values.activityTypeId) {
        errors.activityTypeId = 'Requerido';
    }
    if (!values.subtypeActivityId) {
        errors.subtypeActivityId = 'Requerido';
    }

    return errors
} */

export const PlannedActivityList = props => {
    const [servicePackage, setServicePackage] = useState([]);
    const [activeSpinner, setActiveSpinner] = useState(false);
    const [showList, setShowList] = useState(false);
    const [plannedActivities, setPlannedActivities] = useState([]);
    const [editingActivity, setEditingActivity] = useState(null);
    const [selectedIds, setSelectedIds] = useState([]);

    const [isCheckingInit, setIsCheckingInit] = useState(true);
    const [currentProcess, setCurrentProcess] = useState(null);
    const [creationProgress, setCreationProgress] = useState(null);
    const creationPollRef = useRef(null);
    const handledCreationResultRef = useRef(null);
    const [confirmAction, setConfirmAction] = useState({
        open: false,
        onConfirm: null,
        title: undefined,
        message: undefined,
        confirmLabel: undefined,
        confirmColor: undefined,
    });
    const notify = useNotify();

    const today = new Date().toISOString().split('T')[0];  
    const dateValidation = (value) => {
        if (!value) return 'La fecha es requerida';
        if (new Date(value) < new Date(today)) return 'La fecha debe ser hoy o posterior';
        return undefined; 
    };

    const handleProcessFinished = () => {
        if (creationPollRef.current) {
            clearTimeout(creationPollRef.current);
            creationPollRef.current = null;
        }
        setCurrentProcess(null);
        setCreationProgress(null);
        setPlannedActivities([]);
        setSelectedIds([]);
        setShowList(false);
    };

    const mergeCreationActivities = progress => {
        const processedActivities = progress?.activities || [];
        const processedById = new Map(processedActivities.map(activity => [activity.id, activity]));
        setPlannedActivities(currentActivities =>
            currentActivities.map(activity => processedById.get(activity.id) || activity)
        );
    };

    const scheduleCreationPoll = processId => {
        if (creationPollRef.current) clearTimeout(creationPollRef.current);
        creationPollRef.current = setTimeout(() => pollActivityCreation(processId), 2000);
    };

    const applyCreationProgress = (progress, showNotification = true) => {
        if (!progress) return;

        setCreationProgress(progress);
        mergeCreationActivities(progress);

        if (progress.status === 'Pending' || progress.status === 'Processing') {
            scheduleCreationPoll(progress.planningProcessId);
            return;
        }

        if (creationPollRef.current) {
            clearTimeout(creationPollRef.current);
            creationPollRef.current = null;
        }

        const resultKey = `${progress.id}-${progress.status}-${progress.processedActivities}`;
        if (handledCreationResultRef.current === resultKey) return;
        handledCreationResultRef.current = resultKey;

        if (progress.status === 'Completed') {
            if (showNotification) {
                notify("Las actividades seleccionadas se han creado correctamente.", "success");
            }
            setCreationProgress(null);
            setSelectedIds([]);
            return;
        }

        const failedActivities = (progress.activities || []).filter(activity => !activity.isCreated && activity.error);
        setSelectedIds(failedActivities.map(activity => activity.id));

        if (!showNotification) return;

        if (progress.status === 'Cancelled') {
            notify("Se ha cancelado la creación. Las actividades ya creadas se conservan.", "info");
            return;
        }

        const failedNames = failedActivities
            .slice(0, 3)
            .map(activity => activity.name)
            .join(', ');
        const remainingCount = failedActivities.length - 3;
        const remainingText = remainingCount > 0 ? ` y ${remainingCount} más` : '';
        const detail = failedNames ? `: ${failedNames}${remainingText}` : '';
        notify(
            `${progress.failedActivities} actividad(es) no se han podido crear${detail}. Revisa la columna Error.`,
            "warning"
        );
    };

    const pollActivityCreation = async processId => {
        try {
            const result = await plannedActivitiesProvider.getActivityCreationProgress(processId);
            if (result?.data) {
                applyCreationProgress(result.data);
            }
        } catch (error) {
            console.error("Error al consultar el progreso de creación", error);
            scheduleCreationPoll(processId);
        }
    };

    const isEditingGroup = editingActivity?.typologyName === 'Grupal';
    const isEditingIndividual = editingActivity?.typologyName === 'Individual';

 
    const loadProposals = async (processId) => {
        try {
            setActiveSpinner(true);
            const proposalsRes = await plannedActivitiesProvider.getProposals(processId);
            if (proposalsRes && proposalsRes.data) {
                setPlannedActivities(proposalsRes.data);
                setShowList(true); // Mostramos las tablas
            }
        } catch (error) {
            console.error("Error al cargar las propuestas:", error);
        } finally {
            setActiveSpinner(false);
        }
    };


    useEffect(() => {
        const initializeView = async () => {
            setIsCheckingInit(true);
            try {
                await fetchServicePackages();
                
                const res = await plannedActivitiesProvider.getActivePlanningProcess();
                if (res && res.data && res.data.id) {
                    setCurrentProcess(res.data);
                    
                    // Si ya estaba listo para revisión al entrar a la página, cargamos la tabla
                    if (res.data.statusName === 'ReadyForReview') {
                        await loadProposals(res.data.id);
                        const creationResult = await plannedActivitiesProvider.getActivityCreationProgress(res.data.id);
                        if (creationResult?.data) {
                            applyCreationProgress(creationResult.data, false);
                        }
                    }
                }
            } catch (error) {
                console.error("Error inicializando la vista:", error);
            } finally {
                setIsCheckingInit(false);
            }
        };

        initializeView();

        return () => {
            if (creationPollRef.current) clearTimeout(creationPollRef.current);
        };
    // La inicialización debe ejecutarse una sola vez; el seguimiento posterior usa su propio temporizador.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


   const fetchServicePackages = async () => {
        const res = await servicePackagesProvider.getList(null, {
            pagination: { page: 1, perPage: 100 },
            sort: { field: 'Id', order: 'DESC' }
        });

        if (res) {
            setServicePackage(res?.data);
        }
    };

    const handleCheckStatus = async () => {
        if (!currentProcess?.id) return;
        
        setActiveSpinner(true);
        try {
            const res = await plannedActivitiesProvider.getPlanningProcess(currentProcess.id);
            if (res && res.data) {
                setCurrentProcess(res.data);
                
                if (res.data.statusName === 'ReadyForReview') {
                    console.log("¡El proceso ha finalizado! Cargando propuestas...");
                    await loadProposals(res.data.id); // <-- Cargamos la tabla
                } else if (res.data.statusName === 'Failed') {
                    console.error("El proceso ha fallado:", res.data.errorMessage);
                }
            }
        } catch (error) {
            console.error("Error al comprobar el estado", error);
        } finally {
            setActiveSpinner(false);
        }
    };

    const handleCancelProcess = async () => {
        if (!currentProcess?.id) return;
        
        setActiveSpinner(true);
        try {
            // Llamamos a tu endpoint pasándole el nuevo estado
            await plannedActivitiesProvider.updateProcessStatus(currentProcess.id, "Cancelled");
            
            // Limpiamos la pantalla para que el usuario pueda crear una nueva planificación
            setCurrentProcess(null);
            setPlannedActivities([]);
            setSelectedIds([]);
            setShowList(false);
        } catch (error) {
            console.error("Error al cancelar el proceso", error);
        } finally {
            setActiveSpinner(false);
        }
    };

    const handleValidate = async () => {
        const selectedActivities = plannedActivities.filter(act => selectedIds.includes(act.id));

        if (selectedActivities.length === 0) return;

        setActiveSpinner(true);
        try {
            handledCreationResultRef.current = null;
            const creationResult = await plannedActivitiesProvider.startActivityCreation(
                selectedActivities,
                currentProcess?.id
            );
            if (!creationResult?.data) {
                throw new Error("La API no ha devuelto el lote de creación.");
            }

            applyCreationProgress(creationResult.data, false);
            if (creationResult.data.status === 'Pending' || creationResult.data.status === 'Processing') {
                notify(
                    `Se ha iniciado la creación de ${creationResult.data.totalActivities} actividad(es). Puede volver más tarde sin perder el progreso.`,
                    "info"
                );
            }
        } catch (error) {
            notify(getBusinessErrorMessage(error,
                "No se han podido validar las actividades. Inténtalo de nuevo más tarde."), "error");
            console.error(error);
        } finally {
            setActiveSpinner(false);
        }
    };

    const handleFinishPlanning = async () => {
        if (!currentProcess?.id) return;

        setActiveSpinner(true);
        try {
            await plannedActivitiesProvider.updateProcessStatus(currentProcess.id, "Approved");
            notify("Planificación finalizada correctamente.", "success");
            handleProcessFinished();
        } catch (error) {
            notify("No se ha podido finalizar la planificación.", "error");
            console.error("Error al finalizar la planificación", error);
        } finally {
            setActiveSpinner(false);
        }
    };

    const handleCancelActivityCreation = async () => {
        if (!currentProcess?.id) return;

        try {
            const result = await plannedActivitiesProvider.cancelActivityCreation(currentProcess.id);
            if (result?.data) {
                applyCreationProgress(result.data, false);
                notify("Cancelación solicitada. Se detendrá al terminar la actividad actual.", "info");
            }
        } catch (error) {
            notify("No se ha podido cancelar la creación de actividades.", "error");
            console.error(error);
        }
    };

    const openConfirmAction = (onConfirm, options = {}) => {
        setConfirmAction({
            open: true,
            onConfirm,
            title: options.title,
            message: options.message,
            confirmLabel: options.confirmLabel,
            confirmColor: options.confirmColor,
        });
    };

    const closeConfirmAction = () => {
        setConfirmAction({
            open: false,
            onConfirm: null,
            title: undefined,
            message: undefined,
            confirmLabel: undefined,
            confirmColor: undefined,
        });
    };

    const handleConfirmAction = async () => {
        const action = confirmAction.onConfirm;
        closeConfirmAction();
        if (action) {
            await action();
        }
    };

const formattedExpiration = currentProcess?.expirationAt 
        ? new Date(currentProcess.expirationAt).toLocaleString('es-ES')
        : 'Desconocida';
const isCreatingActivities = creationProgress?.status === 'Pending' || creationProgress?.status === 'Processing';

return (
        <div className="planned-activities-page">
        {/* SPINNER INICIAL DE SEGURIDAD */}
            {isCheckingInit && <Spinner fullscreen />}
            {/* VISTA 1: FORMULARIO ORIGINAL (Solo se muestra si no hay proceso en curso ni lista) */}
            {
                !isCheckingInit && !activeSpinner && !showList && !currentProcess && (
                    <TabbedForm
                        toolbar={null}
                        transform={values => {
                            return {
                                dayIds: Object.entries(values.dias || {})
                                    .filter(([key, value]) => value)
                                    .map(([key]) => parseInt(key)),
                                servicePackageId: values.servicePackageId,
                                maxNumberUsers: values.maxNumberUsers,
                                startDate: values.startDate,
                                endDate: values.endDate,
                                contracts: (values.contracts || []).map(c => c.id)
                            };
                        }}
                    >
                        <FormTab label="Planificador">


                            <Paper elevation={3} style={{ padding: '1.5%', width: '100%', boxSizing: 'border-box' }}>
                                <div className="div-planned">
                                    <span style={{ fontSize: '18px', fontWeight: 'bold' }}>Planificación semanal de actividades</span>
                                    <span> Indique los días a planificar:</span>
                                </div>

                                <div className="grid-dos-columnas-sin-fondo">
                                    <div>
                                        <Typography variant="subtitle1" gutterBottom>
                                            Días de la semana
                                        </Typography>
                                        {diasSemana.map(dia => (
                                            <BooleanInput
                                                key={dia.id}
                                                label={dia.name}
                                                source={`dias.${dia.id}`}
                                                defaultValue={dia.isCheck}
                                            />
                                        ))}

                                    </div>
                                    <div>
                                        <div className="new-line-custom">
                                            <AutocompleteInput
                                                label="Paquete de servicio"
                                                source="servicePackageId"
                                                choices={servicePackage}
                                                validate={[]}
                                                optionText={(record) => record ? record?.name : ''}
                                                optionValue="id"
                                                options={{ InputProps: { autoComplete: 'off' } }}
                                                resettable={true}
                                            />
                                            <TextInput
                                                label="Nº máx. usuarios"
                                                source="maxNumberUsers"
                                                type="number"
                                                validate={[required()]}
                                                fullWidth
                                            />
                                        </div >
                                        <div className="new-line-custom">
                                            <DateInput
                                                label="Fecha inicio"
                                                source="startDate"
                                                validate={[required(), dateValidation]}
                                                onClick={openDatePicker}
                                                onFocus={openDatePicker}
                                                InputLabelProps={{ shrink: true }}
                                                fullWidth 
                                            />
                                            <DateInput
                                                label="Fecha fin"
                                                source="endDate"
                                                validate={[required(), dateValidation]}
                                                onClick={openDatePicker}
                                                onFocus={openDatePicker}
                                                InputLabelProps={{ shrink: true }}
                                                fullWidth 
                                            />
                                        </div >
                                    </div>
                                </div>
                                <PlannedButton setActiveSpinner={setActiveSpinner} setShowList={setShowList} setPlannedActivities={setPlannedActivities} setCurrentProcess={setCurrentProcess} />
                            </Paper>
                        </FormTab>
                        <FormTab label="Contratos" contentClassName="tab-container no-label">
                            <ArrayInput label="Contratos" source="contracts" id="arrayCustomContracts" validate={[required()]} disabled={false}>
                                <SimpleFormIterator disableRemove={false}>
                                    <FormDataConsumer>
                                        {({ scopedFormData, getSource }) => {
                                            const source = getSource('');
                                            const indexMatch = source.match(/\[(\d+)\]/);

                                            const index = indexMatch ? indexMatch[1] : null;

                                            return (
                                                <>
                                                    <AutoCompleteCustom
                                                        type={"CONTRACTS"}
                                                        label={"Contrato"}
                                                        placeholder={"Buscar contrato"}
                                                        disabled={false}
                                                        data={scopedFormData}
                                                        index={index}
                                                        requiredInput={true}
                                                        {...props} />
                                                </>
                                            );
                                        }}
                                    </FormDataConsumer>
                                </SimpleFormIterator>
                            </ArrayInput>

                            <TextInput style={{ display: 'none' }} source="contractsValidation" />
                        </FormTab>


                    </TabbedForm>
                )
            }

            {/* VISTA 2: PANTALLA INFORMATIVA DE ESPERA */}
            {
                !isCheckingInit && !activeSpinner && !showList && currentProcess && (currentProcess.statusName === 'Pending' || currentProcess.statusName === 'Running') && (
                    <Paper elevation={3} style={{ padding: '3rem', textAlign: 'center', marginTop: '2rem' }}>
                        <CircularProgress size={60} style={{ marginBottom: '2rem' }} />
                        <Typography variant="h5" gutterBottom style={{ fontWeight: 'bold' }}>
                            Proceso de planificación en curso
                        </Typography>
                        <Typography variant="body1" style={{ marginBottom: '1rem', color: '#555' }}>
                            Estamos generando las propuestas de actividades (ID: {currentProcess.id}). <br/>
                            El estado actual es: <strong>{currentProcess.statusName}</strong>.
                        </Typography>
                        <Typography variant="body2" style={{ marginBottom: '1rem', color: '#777' }}>
                            Puede esperar en esta pantalla o volver más tarde. Le enviaremos un correo cuando termine.
                        </Typography>
                        <Typography variant="caption" style={{ display: 'block', marginBottom: '2rem', color: '#d32f2f' }}>
                            * Si no recibimos respuesta del motor de IA, este proceso caducará automáticamente el: {formattedExpiration}
                        </Typography>
                        
                        <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem' }}>
                            <Button 
                                variant="outlined" 
                                color="secondary" 
                                onClick={() => openConfirmAction(handleCancelProcess, {
                                    title: 'Confirmar cancelación',
                                    message: '¿Seguro que quieres cancelar la planificación en curso?',
                                    confirmLabel: 'Cancelar planificación',
                                    confirmColor: 'secondary',
                                })}
                            >
                                Cancelar Planificación
                            </Button>
                            <Button 
                                variant="contained" 
                                color="primary" 
                                onClick={handleCheckStatus}
                            >
                                Comprobar estado actual
                            </Button>
                        </div>
                    </Paper>
                )
            }

            {/* VISTA 3: MENSAJE DE ERROR */}
            {
                !isCheckingInit && !activeSpinner && !showList && currentProcess && currentProcess.statusName === 'Failed' && (
                    <Paper elevation={3} style={{ padding: '3rem', textAlign: 'center', marginTop: '2rem' }}>
                        <Typography variant="h5" color="error" gutterBottom style={{ fontWeight: 'bold' }}>
                            La planificación ha fallado
                        </Typography>
                        <Typography variant="body1" style={{ marginBottom: '2rem' }}>
                            Motivo: {currentProcess.errorMessage || 'Error desconocido al contactar con Planisto.'}
                        </Typography>
                        <Button variant="outlined" onClick={() => setCurrentProcess(null)}>
                            Limpiar y volver a intentar
                        </Button>
                    </Paper>
                )
            }

            {/* VISTA 4: ERROR  */}
            {
                !isCheckingInit && !activeSpinner && !showList && currentProcess && currentProcess.statusName === 'ReadyForReview' && (
                    <Paper elevation={3} style={{ padding: '3rem', textAlign: 'center', marginTop: '2rem' }}>
                        <Typography variant="h5" color="error" gutterBottom style={{ fontWeight: 'bold' }}>
                            Error al cargar la tabla de propuestas
                        </Typography>
                        <Typography variant="body1" style={{ marginBottom: '2rem' }}>
                            El proceso ha finalizado correctamente en BBDD, pero no hemos podido descargar el JSON de las actividades.
                            (Revisa la consola F12 para más detalles).
                        </Typography>
                        <Button variant="outlined" color="primary" onClick={() => loadProposals(currentProcess.id)}>
                            Reintentar carga de la tabla
                        </Button>
                    </Paper>
                )
            }
            {!activeSpinner && showList && plannedActivities && !editingActivity && (
                <Paper elevation={3} className="planned-header">
                    <div className="planned-header-main">
                        <span className="planned-header-eyebrow">Planisto</span>
                        <span className="planned-header-title">Planificación de actividades</span>
                        <span className="planned-header-subtitle">Propuestas generadas para revisar y validar</span>
                    </div>
                    <div className="planned-header-summary">
                        <span>{plannedActivities.length} propuestas</span>
                        <span>{selectedIds.length} seleccionadas</span>
                    </div>
                </Paper>
            )}
            {!activeSpinner && showList && isCreatingActivities && (
                <Paper elevation={3} style={{ padding: '1.5rem', margin: '1rem 0' }}>
                    <Typography variant="h6" gutterBottom>
                        {creationProgress.cancellationRequested
                            ? 'Deteniendo la creación de actividades…'
                            : 'Creando actividades en segundo plano'}
                    </Typography>
                    <LinearProgress
                        variant="determinate"
                        value={Math.min(100, creationProgress.percentage || 0)}
                        style={{ height: 10, borderRadius: 5, margin: '1rem 0' }}
                    />
                    <Typography variant="body1">
                        {creationProgress.processedActivities} de {creationProgress.totalActivities} procesadas
                        {' · '}{creationProgress.createdActivities} creadas
                        {' · '}{creationProgress.failedActivities} con error
                    </Typography>
                    <Typography variant="body2" style={{ color: '#666', marginTop: '0.5rem' }}>
                        Puede salir de esta pantalla y volver más tarde. El progreso y los errores quedan guardados.
                    </Typography>
                    <Button
                        variant="outlined"
                        color="secondary"
                        disabled={creationProgress.cancellationRequested}
                        onClick={() => openConfirmAction(handleCancelActivityCreation, {
                            title: 'Detener creación',
                            message: 'Se conservarán las actividades ya creadas. ¿Quieres detener las pendientes?',
                            confirmLabel: 'Detener',
                            confirmColor: 'secondary',
                        })}
                        style={{ marginTop: '1rem' }}
                    >
                        Detener creación
                    </Button>
                </Paper>
            )}
            {!activeSpinner && !isCreatingActivities && showList && plannedActivities && (!editingActivity || !isEditingGroup) && (
                <ActivitiesTable
                    props={props}
                    isGroup={false}
                    nameCSV={"PropuestasIndividuales"}
                    editingActivity={editingActivity}
                    setEditingActivity={setEditingActivity}
                    plannedActivities={plannedActivities}
                    setPlannedActivities={setPlannedActivities}
                    selectedIds={selectedIds}
                    setSelectedIds={setSelectedIds}
                />
            )}
            <br></br>
            {!activeSpinner && !isCreatingActivities && showList && plannedActivities && (!editingActivity || !isEditingIndividual) && (
                <ActivitiesTable
                    props={props}
                    isGroup={true}
                    nameCSV={"PropuestasGrupales"}
                    editingActivity={editingActivity}
                    setEditingActivity={setEditingActivity}
                    plannedActivities={plannedActivities}
                    setPlannedActivities={setPlannedActivities} 
                    selectedIds={selectedIds}
                    setSelectedIds={setSelectedIds}
                />
            )}
            {!activeSpinner && !isCreatingActivities && showList && plannedActivities && !editingActivity && (
                <div className="planned-floating-actions">
                    <span className="planned-floating-counter">
                        {selectedIds.length} seleccionadas
                    </span>
                    <Button
                        className="planned-floating-button"
                        variant="outlined"
                        color="primary"
                        onClick={() => openConfirmAction(handleFinishPlanning, {
                            title: 'Descartar toda la planificación',
                            message: 'Se descartará toda la planificación, incluidas las propuestas pendientes o con errores. No podrás volver a editarla. ¿Quieres continuar?',
                            confirmLabel: 'Descartar',
                            confirmColor: 'primary',
                        })}
                    >
                        Descartar toda la planificación
                    </Button>

                    <Button
                        disabled={selectedIds.length === 0}
                        className="planned-floating-button"
                        variant="contained"
                        color="primary"
                        onClick={() => openConfirmAction(handleValidate)}
                    >
                        Validar
                    </Button>
                </div>
            )}
            {activeSpinner && <Spinner fullscreen />}
            <ConfirmActionDialog
                open={confirmAction.open}
                onClose={closeConfirmAction}
                onConfirm={handleConfirmAction}
                title={confirmAction.title}
                message={confirmAction.message}
                confirmLabel={confirmAction.confirmLabel}
                confirmColor={confirmAction.confirmColor}
            />
        </div>

    )
}

const PlannedButton = (props) => {
    const { setActiveSpinner, setCurrentProcess } = props; // Extraemos setCurrentProcess
    const { values, invalid } = useFormState();

    const fetchPlannedActivities = async (data) => {
        try {
            const res = await plannedActivitiesProvider.initialProcess(data);
            
            if (res && res.data && res.data.id) {
                console.log("Proceso iniciado con éxito:", res.data);
                setCurrentProcess(res.data); // <-- GUARDAMOS EL PROCESO (Cambia la vista automáticamente)
                setActiveSpinner(false);
            } else {
                setActiveSpinner(false);
                console.error("No se pudo iniciar el proceso de planificación.");
            }
        } catch (error) {
            console.error("Error al iniciar la planificación:", error);
            setActiveSpinner(false);
        }
    };

    const handleData = () => {
        if (isFormValid) {
            setActiveSpinner(true);
            const dto = {
                dayIds: Object.entries(values.dias || {})
                    .filter(([key, value]) => value)
                    .map(([key]) => parseInt(key)),
                servicePackageId: values.servicePackageId,
                maxNumberUsers: values.maxNumberUsers,
                startDate: values.startDate,
                endDate: values.endDate,
                contracts: (values.contracts || []).map(c => c.id),
            };
            fetchPlannedActivities(dto);
        }
    };

    const isFormValid = !invalid;  // Si el formulario tiene algún campo inválido, deshabilitamos el botón

    return (
        <div style={{ justifyItems: 'center' }}>
            <Card
                className={isFormValid ? "button-planned" : "button-planned-disabled"}
                onClick={handleData}
                disabled={!isFormValid}  // Deshabilitar si el formulario no es válido
            >
                <Typography style={{ fontSize: "1.2rem" }} align="center">
                    Planificar
                </Typography>
            </Card>
        </div>
    );
};
